import { Component } from '@angular/core';
import { faToolbox } from '@fortawesome/pro-solid-svg-icons';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'wilson-working-time-model-icon-renderer',
  template: `
    <div
      class="icon-square bg-light text-white flex-shrink-0 me-3 d-flex justify-content-center"
    >
      <fa-icon [icon]="faToolbox"></fa-icon>
    </div>
  `,
  styles: [
    `
      .icon-square {
        padding: 11px;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        margin-top: 9px;
        margin-left: 10px;
        text-align: center;
      }
      fa-icon {
        font-size: 18px;
      }
    `,
  ],
  standalone: false,
})
export class WorkingTimeModelIconRendererComponent
  implements AgRendererComponent
{
  faToolbox = faToolbox;
  public cellValue!: string;

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams) {
    this.cellValue = this.getValueToDisplay(params);
    return true;
  }

  private getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }
}
